document.addEventListener('DOMContentLoaded', () => {
    const copytexts = document.querySelectorAll('.js-copy-text');
    copytexts.forEach((copytext, index) => {
        let copyTimeout = false;
        copytext.addEventListener('click', (e) => {
            e.preventDefault();
            const text = copytext.getAttribute('data-text') as string;

            const input = document.createElement('input');
            document.body.appendChild(input);
            input.value = text;
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('contenteditable', 'contenteditable');
            input.style.position = 'fixed';
            input.style.opacity = '0';
            input.focus();
            input.select();
            document.execCommand('copy');
            input.remove();

            if (copyTimeout) {
                clearInterval(copyTimeout);
            }

            copytext.classList.add('tooltip--active');
            copyTimeout = setTimeout(() => {
                copytext.classList.remove('tooltip--active');
            }, 2000);
        });
    });
});
